import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { NavigationSection, SectionKey } from "../components/layout/AppSidebar";
import { defaultNavigationSections } from "../utils/uiVariables";

interface InspectorState {
  sections: Record<SectionKey, NavigationSection>;
}

const initialState: InspectorState = {
  sections: defaultNavigationSections,
};

export const sectionsSlice = createSlice({
  name: 'sections',
  initialState,
  reducers: {
    updateSections(state, action) {
      state.sections = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateSections } = sectionsSlice.actions;

export const sectionLabelsSelector = (state: RootState, key: SectionKey) => state.sectionStore.sections[key].labels;

export default sectionsSlice.reducer;